// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translations: {
    //Traduções gerais
    Logoff: 'Sair',
    Name: 'Nome',
    FullName: 'Nome completo',
    Type: 'Tipo',
    Created: {
      Default: 'Criado',
      At: 'Criado em',
    },
    Updated: {
      Default: 'Atualizado',
      At: 'Atualizado em',
    },
    Edit: 'Editar',
    User: 'Usuários',

    Clone: 'Copiar',
    View: 'Visualizar',
    Save: 'Salvar',
    Send: 'Enviar',
    Cancel: 'Cancelar',
    Delete: 'Apagar',
    New: 'Novo',
    logoff: 'Sair',
    Email: 'Email',
    AlertDialog: {
      Title: 'Você tem certeza?',
      Delete: { //ATENÇÃO, ISSO PODE SER MELHORADO
        Flow: 'Realmente deseja apagar esse flow? Esse processo não pode ser desfeito.',
        Step: 'Realmente deseja apagar esse passo? Esse processo não pode ser desfeito.',
        Report: 'Realmente deseja apagar esse Relatório? Esse processo não pode ser desfeito.',
      }
    },
    Add: {
      Default: 'Adicionar',
      Filter: 'Adicionar filtro',
      Choice: 'Adicionar opção'
    },
    CountryCode: 'CPF',
    Close: 'Fechar',
    BaseValue: 'Valor base',

    //Login
    SignIn: 'Entrar',
    Password: 'Senha',
    RememberMe: 'Lembrar meu usuário',
    ForgotPassword: 'Esqueceu sua senha?',
    EnterEmail: "Digite seu email para recuperar sua senha.",
    EnterPassword: "Digite a sua nova senha abaixo.",
    SignUp: "Ainda não tem uma conta? Increva-se",

    //Flow
    flow: 'Flow',
    Saved: { //ATENÇÃO, ISSO PODE SER MELHORADO
      Flow: 'Flow salvo!',
      Step: 'Passo salvo!',
      Report: 'Relatório salvo!'
    },
    Step: {
      Type: 'Tipo',
      Code: 'Código do passo',
      DefaultActionCode: 'Código padrão da próxima Ação',
      PersistData: 'Salvar resposta?',
      New: 'Criar novo passo',
      Edit: 'Editar passo',
      Excluded: 'Passo excluído',
      ErrorMessage: 'Mensagem de erro',
      Text: 'Texto da mensagem',
      Choice: 'Opções'
    },
    Choice: {
      Character: 'Índice',
      Text: 'Texto da opção',
    },
    CheckValue: 'Valor esperado',
    Welcome: 'Boas vindas',
    Text: 'Texto',
    MultipleChoice: 'Múltipla escolha',
    Statement: 'Afirmação',
    QnA: 'Perguntas e respostas',
    NationalId: 'CPF',
    Ending: 'Encerramento',
    MinLength: 'Tamanho mínimo',
    MaxLength: 'Tamanho máximo',
    Mask: 'Máscara',
    Multiline: 'Mais de uma linha?',
    BlackList: 'Lista proibida',
    AllowMultiple: 'Permitir mais de um?',
    ValidValues: 'Valores válidos',
    Rules: 'Regras',
    Action: 'Ação',
    Conditions: 'Condições',
    GoTo: 'Ir para',
    StayOk: 'Continuar aqui após êxito',
    StayError: 'Continuar aqui após erro',
    Return: 'Voltar',

    // ActionTypes
    Equals: '=',
    NotEquals: '!=',
    Contains: 'Contém',
    NotContains: 'Não contém',
    GreaterThan: '>',
    GreaterOrEquals: '>=',
    LessThan: '<',
    LessOrEquals: '<=',
    In: 'Dentro de',
    NotIn: 'Fora de',

    //Reports
    Reports: 'Relatórios',
    Report: 'Relatório',
    ReportsQuantity_zero: "Nenhum registro encontrado",
    ReportsQuantity_one: "{{count}} registro encontrado",
    ReportsQuantity_other: "{{count}} registros encontrados",
    Date: {
      Start: 'Data de início',
      End: 'Data final'
    },
    AutoRefresh: 'Atualizar automaticamente',
    Fields: 'Campos',
    Field: 'Campo',
    Filters: 'Filtros',
    Value: 'Valor',
  }
}
